import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import { ApiService } from "../../service/ApiService";

export const getProxies = createAsyncThunk(
  "freeProxy/getProxy",
  async (params, { rejectWithValue }) => {
    try {
      return await ApiService.getProxyServers(params);
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const getProxyPagination = createAsyncThunk(
  "freeProxy/getPaginationData",
  async (params, { rejectWithValue }) => {
    try {
      return await ApiService.getPaginationProxyServers(params);
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const getFreeProxiesForExport = createAsyncThunk(
  "freeProxy/getFreeProxiesForExport",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await ApiService.getProxiesForExports(params);

      return data;
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const serverProxySave = createAction("freeProxy/serverProxySave");
export const paginationProxySave = createAction(
  "freeProxy/paginationProxySave",
);
export const openDropDown = createAction("freeProxy/openDropDown");
export const clearSelectedCountry = createAction(
  "freeProxy/clearSelectedCountry",
);

export const toFirstRenderFalse = createAction("freeProxy/toFirstRenderFalse");
